// 点赞业务
import { followings, unFollowings } from '@/api/user'
import { Toast } from 'vant'
export const followMixin = {
  data () {
    return {
      // 点赞|取消点赞  请求中
      followLoading: false
    }
  },
  methods: {
    // 请求操作
    async handlerFollow (articleOrComment) {
      try {
        this.followLoading = true
        if (articleOrComment.is_followed) {
          await unFollowings(articleOrComment.aut_id)
        } else {
          await followings(articleOrComment.aut_id)
        }
        this.followLoading = false
        articleOrComment.is_followed = !articleOrComment.is_followed
        Toast.success(articleOrComment.is_followed ? '关注成功' : '取消关注')
      } catch (e) {
        Toast.fail('操作失败')
        this.followLoading = false
      }
    }
  }
}
